import { render } from "./Profile.vue?vue&type=template&id=714653bf&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=714653bf&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714653bf"]])

export default __exports__